module.exports = __webpack_public_path__ + "static/img/menu.14f6b2e3.svg";